module.exports = __webpack_public_path__ + "img/logo-1.98670b21.png";